import { ROUTE_ORGANISATIONS, ROUTE_RNP } from './routeHelpers';
import {
  ADD_MEMBER,
  CREATE_NEW_ROLE,
  CUSTOM_ROLE_LIST,
  EDIT_ROLE,
  ORGANISATIONS,
  ROLES_AND_PERMISSIONS,
  SYSTEM_ROLE_LIST,
} from '../../utils/constants';

const organisationsRoutes = [
  {
    path: ROUTE_ORGANISATIONS.organisations,
    name: ORGANISATIONS,
  },
  {
    path: ROUTE_ORGANISATIONS.organisationMembers,
    name: ':code',
  },
  {
    path: ROUTE_ORGANISATIONS.addMember,
    name: ADD_MEMBER,
  },
];

const rolesNPermissionsRoutes = [
  {
    path: ROUTE_RNP.rolesNPermissions,
    name: ROLES_AND_PERMISSIONS,
  },
  {
    path: ROUTE_RNP.systemRoles,
    name: SYSTEM_ROLE_LIST,
  },
  {
    path: ROUTE_RNP.customRoles,
    name: CUSTOM_ROLE_LIST,
  },
  {
    path: ROUTE_RNP.createNewRole,
    name: CREATE_NEW_ROLE,
  },
  {
    path: ROUTE_RNP.updateCustomRole,
    name: EDIT_ROLE,
  },
];

export const routes = [...organisationsRoutes, ...rolesNPermissionsRoutes];
